import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { updateUser } from '../lib/store';
export function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: '',
    lastName: '',
    email: '',
    phone: '',
    pass: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    updateUser({
      name: form.name,
      lastName: form.lastName,
      email: form.email,
      phone: form.phone,
      loggedIn: true,
      isGuest: false
    });
    navigate('/');
  };
  return <div className="min-h-screen bg-dark flex justify-center" data-id="element-1027">
      <div className="w-full max-w-md bg-dark flex flex-col" data-id="element-1028">
        <header className="p-6 flex items-center gap-4 border-b border-white/5" data-id="element-1029">
          <Link to="/login" className="text-light hover:text-gold" data-id="element-1030">
            <ArrowLeft size={24} data-id="element-1031" />
          </Link>
          <h2 className="text-lg font-medium text-light" data-id="element-1032">Crear cuenta</h2>
        </header>
        <form onSubmit={handleSubmit} className="p-6 space-y-4 flex-1 overflow-y-auto" data-id="element-1033">
          <input required placeholder="Nombre" value={form.name} onChange={e => setForm({
          ...form,
          name: e.target.value
        })} className="w-full bg-dark-card border border-white/10 rounded-xl px-4 py-3 text-light focus:border-gold outline-none" data-id="element-1034" />
          <input required placeholder="Apellido" value={form.lastName} onChange={e => setForm({
          ...form,
          lastName: e.target.value
        })} className="w-full bg-dark-card border border-white/10 rounded-xl px-4 py-3 text-light focus:border-gold outline-none" data-id="element-1035" />
          <input required type="email" placeholder="Email" value={form.email} onChange={e => setForm({
          ...form,
          email: e.target.value
        })} className="w-full bg-dark-card border border-white/10 rounded-xl px-4 py-3 text-light focus:border-gold outline-none" data-id="element-1036" />
          <input required type="tel" placeholder="Celular" value={form.phone} onChange={e => setForm({
          ...form,
          phone: e.target.value
        })} className="w-full bg-dark-card border border-white/10 rounded-xl px-4 py-3 text-light focus:border-gold outline-none" data-id="element-1037" />
          <input required type="password" placeholder="Contraseña" value={form.pass} onChange={e => setForm({
          ...form,
          pass: e.target.value
        })} className="w-full bg-dark-card border border-white/10 rounded-xl px-4 py-3 text-light focus:border-gold outline-none" data-id="element-1038" />

          <label className="flex items-start gap-3 mt-6" data-id="element-1039">
            <input required type="checkbox" className="mt-1 accent-gold" data-id="element-1040" />
            <span className="text-xs text-light-muted" data-id="element-1041">
              Acepto los términos y condiciones y la política de privacidad.
            </span>
          </label>

          <button type="submit" className="w-full bg-gold text-dark py-4 rounded-xl font-semibold mt-8 hover:bg-gold-hover transition-colors" data-id="element-1042">
            Crear cuenta
          </button>
        </form>
      </div>
    </div>;
}